import { Routes } from '@angular/router';
import { TopicComponent } from "./topic/topic.component";
import { TopicListComponent } from './topic-list/topic-list.component';
import { AuthGuard } from '../../guards/auth.guard';

export const topicRoutes: Routes = [
    {
      path: 'topics',
      canActivate: [AuthGuard],
      data: {
        breadcrumb: {}
      },
      children: [
        {
          path: '',
          component: TopicListComponent,
          data: {
            type: 'list',
            breadcrumb: {
              bcType: 'Display',
              action: 'List',
              value: 'Topics',
              type: 'Topic'
            }
          }
        },
        {
          path: 'create',
          component: TopicComponent,
          data: {
            type: 'create',
            breadcrumb: {
              bcType: 'Display',
              action: 'Create',
              value: 'Topics',
              type: 'Topic'
            }
          }
        },
        {
          path: ':topicId',
          data: {
            breadcrumb: {
              bcType: 'LookUp',
              value: 'topicId',
              type: 'Topic'
            }
          },
          children: [
            {
              path: 'edit',
              component: TopicComponent,
              data: {
                type: 'edit',
                breadcrumb: {
                  bcType: 'Display',
                  action: 'Edit'
                }
              }
            }
          ]
        }
        ]
    }
  ]
;
